const env = process.env.NODE_ENV;
const tokenUserInfo = process.env.VUE_APP_COOKIE_AUTH_UI;
const cookieSecure = process.env.VUE_APP_COOKIE_SECURE == "true" ? true : null;
const cookieDomain = process.env.VUE_APP_COOKIE_DOMAIN;

export default {
  UPDATE_AUTHENTICATED_USER(state, user) {
    $cookies.set(tokenUserInfo, user, null, null, cookieDomain, cookieSecure);
  },
  UPDATE_LOGIN_GROUP(state, group) {
    state.loginGroup = group;
  }
};
